import Vue from "vue";
import moment from "moment";
import "moment-timezone";
import store from "@/store";

Vue.filter("reverse", function (value) {
  // slice to make a copy of array, then reverse the copy
  return value.slice().reverse();
});

Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).fromNow();
  }
});

Vue.filter("adjustToTimezone", function (value, format = "DD/MM/YYYY HH:mm") {
  if (!value) return "";

  let selectedTimezone = store.state.Setting.timeZone?.value;

  if (!selectedTimezone) {
    selectedTimezone = localStorage.getItem("timeZone");
  }

  // El valor llega con el offset original del timestamp; lo mostramos en Bruselas
  const brusselsMoment = moment.tz(value, "Europe/Brussels");

  if (!selectedTimezone) return brusselsMoment.format(format);

  return brusselsMoment.clone().tz(selectedTimezone).format(format);
});
